import { decryptCredentials } from "./cifrate";

export function isTest() {
  return decryptCredentials(process.env.REACT_APP_AWS_REGION) === "us-east-2"
}
